import axios, { Canceler } from 'axios';

import { AppNS } from 'app';
import { ApiNS } from '../api';
import { FileInfo } from 'app/ui/components/multi-file-uploader/MultiFileUploader';
import {
  parseDocumentResponse,
  parseAgencyDocumentsData,
} from './agency-documents-parsers';
import { API_URL } from '../../core/config';

const DOCUMENTS_URL = 'documents';

const CancelToken = axios.CancelToken;
let cancel: Canceler;

export function apiGetAgencyDocuments(params: AppNS.Params): Promise<any> {
  if (cancel !== undefined) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/${DOCUMENTS_URL}.json`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
        params,
      })
      .then(({ data }) => {
        if (data.results) {
          resolve(parseAgencyDocumentsData(data.results));
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function apiAddAgencyDocument(
  reqData: ApiNS.AddAgencyDocumentRequest
): Promise<FileInfo> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/${DOCUMENTS_URL}.json?return_properties=true`, reqData)
      .then(({ data }) => {
        if (data.model) {
          // Added timeout because of s3 404 error when private url is invoked immediately
          setTimeout(() => {
            resolve(parseDocumentResponse(data.model));
          }, 500);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
export function apiUpdateAgencyDocument(
  reqData: ApiNS.UpdateAgencyDocumentRequest
): Promise<FileInfo> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/${DOCUMENTS_URL}.json?return_properties=true`, reqData)
      .then(({ data }) => {
        if (data.model) {
          // Added timeout because of s3 404 error when private url is invoked immediately
          setTimeout(() => {
            resolve(parseDocumentResponse(data.model));
          }, 500);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function apiDeleteAgencyDocument(id: string): Promise<FileInfo> {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${API_URL}/${DOCUMENTS_URL}.json`, {
        params: { id },
      })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.id);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
